import React, { useState } from "react";
import { Upload } from "antd";
import { LoadingOutlined, CloudUploadOutlined } from "@ant-design/icons";
import { errorMessage } from "../../../helpers/errorMessageFunc";

const dummyRequest = async ({ file, onSuccess }) => {
	setTimeout(() => {
		onSuccess("ok");
	}, 0);
};

const getBase64Value = (img, callback) => {
	const reader = new FileReader();
	reader.readAsDataURL(img);
	reader.onload = () => {
		callback(reader.result);
	};
};

const beforeImageUpload = (file) => {
	const fileIsValidImage =
		file.type === "image/jpeg";
	const fileIsValidSize = file.size / 1024 / 1024 <= 1; // less than 1 MB

	if (!fileIsValidImage) {
		errorMessage("Please upload jpeg file.");
		return false;
	}

	if (!fileIsValidSize) {
		errorMessage(
			"File exceeds 1 MB."
		);
		return false;
	}

	return fileIsValidImage && fileIsValidSize;
};

const ImageUpload = (props) => {
	const [imageBase64Value, setImageBase64Value] = useState("");
	const [imageLoading, setImageLoading] = useState(false);

	const handleImageUpload = (info) => {
		const { file } = info;

		if (file.status === "uploading") {
			setImageLoading(true);
		}

		if (file.status === "done" && file.originFileObj) {
			getBase64Value(file.originFileObj, (imageBase64Value) => {
				setImageBase64Value(imageBase64Value);
				setImageLoading(false);
				props.onChange(imageBase64Value);
			});
		}
	};

	return (
		<Upload
			name="image"
			listType="picture-card"
			accept={".jpg"}
			customRequest={dummyRequest}
			showUploadList={false}
			beforeUpload={beforeImageUpload}
			onChange={handleImageUpload}>
			{imageBase64Value ? (
				<img src={imageBase64Value} alt="Listing" width={100} />
			) : (
				<div>
					{imageLoading ? (
						<LoadingOutlined color={"red"} />
					) : (
						<CloudUploadOutlined color={"red"} />
					)}
					<div className="ant-upload-text">Upload</div>
				</div>
			)}
		</Upload>
	);
};
export default ImageUpload;
